<p>currency-editor works!</p>
